import type { CSSProperties } from "react";

const MOBILE_BREAKPOINT = 768;
const FRAME_GUTTER_PX = 8;
const FRAME_VERTICAL_GUTTERS_PX = FRAME_GUTTER_PX * 2;

export type VisibleDialogFrame = Pick<CSSProperties, "top" | "maxHeight" | "transform">;

export const isIosMobileViewport = () => {
  if (typeof window === "undefined" || typeof navigator === "undefined") return false;

  const isIosDevice = /iPhone|iPad|iPod/i.test(navigator.userAgent)
    || (/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
  return isIosDevice && window.innerWidth < MOBILE_BREAKPOINT;
};

const readNavigationHeight = () => {
  const navigation = document.querySelector<HTMLElement>("nav.fixed.bottom-0");
  const measuredHeight = navigation?.getBoundingClientRect().height;

  if (measuredHeight && measuredHeight > 0) return measuredHeight;

  const configuredHeight = window.getComputedStyle(document.documentElement)
    .getPropertyValue("--player-nav-height")
    .trim();
  const parsedHeight = Number.parseFloat(configuredHeight);

  if (configuredHeight.endsWith("rem") && Number.isFinite(parsedHeight)) {
    const rootFontSize = Number.parseFloat(
      window.getComputedStyle(document.documentElement).fontSize,
    );
    return parsedHeight * (Number.isFinite(rootFontSize) ? rootFontSize : 16);
  }

  return Number.isFinite(parsedHeight) ? parsedHeight : 48;
};

export const getVisibleDialogFrame = (): VisibleDialogFrame | undefined => {
  if (!isIosMobileViewport()) return undefined;

  const viewport = window.visualViewport;
  const offsetTop = viewport?.offsetTop ?? 0;
  const visibleHeight = viewport?.height ?? window.innerHeight;
  const navigationHeight = readNavigationHeight();

  return {
    top: offsetTop + FRAME_GUTTER_PX,
    maxHeight: Math.max(0, visibleHeight - navigationHeight - FRAME_VERTICAL_GUTTERS_PX),
    transform: "translate(-50%, 0)",
  };
};